import { render } from "./Loading.vue?vue&type=template&id=a6d8153c&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=a6d8153c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a6d8153c"

export default script